import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import {
  CreateReviewAnalysisCampaignPayload,
  ReviewAnalysisCampaign,
} from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

interface UseCreateReviewAnalysisCampaignMutationParams {
  onError?: () => void
  onSuccess?: (campaign: ReviewAnalysisCampaign) => void
}

export const useCreateReviewAnalysisCampaignMutation = ({
  onError,
  onSuccess,
}: UseCreateReviewAnalysisCampaignMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateReviewAnalysisCampaignPayload) =>
      ReviewAnalysisApiService.createCampaign(payload),
    onError: () => {
      onError?.()
    },
    onSuccess: (campaign) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_CAMPAIGNS],
      })
      onSuccess?.(campaign)
    },
  })
}
